import computed from './view_case_details_computed';
import dataMethods from './view_case_details_data_methods';
import documentMethods from './view_case_details_document_methods';
import assignmentMethods from './view_case_details_assignment_methods';
import { create_view_case_details_state } from './view_case_details_state';
import BlockingLoaderOverlay from '@/components/config_components/BlockingLoaderOverlay/BlockingLoaderOverlay.vue';
import CaseVerificationCard from '@/components/x-verdict/CaseVerificationCard.vue';

function current_route_case_key(component) {
  return JSON.stringify({
    case_code: component.$route?.params?.caseCode || '',
    application_id: component.$route?.query?.application_id || '',
    entity_profile_id: component.$route?.query?.entity_profile_id || '',
    entity_type_id: component.$route?.query?.entity_type_id || '',
    tab: component.$route?.query?.tab || '',
  });
}

function refresh_case_details() {
  const next_route_key = current_route_case_key(this);
  if (this._last_route_case_key === next_route_key) {
    return;
  }

  this._last_route_case_key = next_route_key;
  this.active_tab = valid_initial_tab(this.$route?.query?.tab) || this.active_tab;
  this.people_panel_collapsed = true;
  this.action_decision_modal = '';
  this.action_decision_reason = '';
  this.action_completed = false;
  this.verification_checks = [];
  this.loading_verification_checks = false;
  this.running_verification_keys = [];
  this.verification_error = '';
  this.resolved_entity_profile_id = null;
  this.resolved_entity_type_id = null;
  this.load_current_case_status();
  this.load_decision_workflow();
  this.load_case_facts();
  this.load_documents();
  this.load_time_journals();
  this.load_notes();
  this.load_audit_logs();
  this.load_assigned_users();
  this.load_risk_panel();
  this.load_sla_runtimes();
}

function valid_initial_tab(tab_key = '') {
  const key = String(tab_key || '').trim().toLowerCase();
  return ['reasoning', 'documents', 'time', 'notes', 'audit'].includes(key) ? key : '';
}

export default {
  name: 'ViewCaseDetails',
  components: {
    BlockingLoaderOverlay,
    CaseVerificationCard,
  },
  computed,
  data: () => create_view_case_details_state(),
  created() {
    refresh_case_details.call(this);
  },
  beforeUnmount() {
    this.clear_fact_edit_success();
  },
  watch: {
    '$route.fullPath': {
      handler() {
        refresh_case_details.call(this);
      },
    },
  },
  methods: {
    ...dataMethods,
    ...documentMethods,
    ...assignmentMethods,
    open_action_modal(action) {
      this.action_decision_modal = action;
      this.action_decision_reason = '';
      this.notes_error = '';
      this.notes_success = '';
    },
    close_action_modal() {
      this.action_decision_modal = '';
    },
    async confirm_action() {
      const action_label = this.selected_sensible_action.modal_title;
      const context = String(this.action_decision_reason || '').trim();

      if (!action_label || typeof this.submit_note !== 'function') {
        return;
      }

      this.new_note_body = `${action_label} confirmed.${context ? ` ${context}` : ''}`;
      await this.submit_note();
      if (this.notes_error) {
        return;
      }

      if (this.action_decision_modal === 'payout') {
        this.action_completed = true;
      }
      this.close_action_modal();
    },
    async undo_action() {
      this.notes_error = '';
      this.notes_success = '';
      this.new_note_body = 'Payout authorisation undone.';
      await this.submit_note();
      if (!this.notes_error) {
        this.action_completed = false;
      }
    },
  },
};
